// NAV MAIN: MEGA MENU
// See; http://edenspiekermann.github.io/a11y-toggle/#connected-toggles


var fn_nav_megamenu = function () {

  // 0 > Collapse Toggle
  function collapse (toggle) {
    var collapsibleBox = document.getElementById(toggle.getAttribute('data-a11y-toggle'))
    collapsibleBox.setAttribute('aria-hidden', true)
    toggle.setAttribute('aria-expanded', false)
  }


  // 1 > TOGGLING MAIN NAV PANEL
  function collapseAll_navmain (event) {
    toggler_navmain
      .filter(function (t) {
        return t !== event.target
      })
      .forEach(collapse)
  }
  var toggler_navmain = Array.prototype.slice.call(
    document.querySelectorAll('.nav--main > li > [data-a11y-toggle]')
  )
  // console.log(toggler_navmain);
  toggler_navmain.forEach(function (toggle) {
    toggle.addEventListener('click', collapseAll_navmain)
  })


  // 2 > TOGGLING MEGAMENU PANEL
  function collapseAll_megamenu_panel (event) {
    toggler_megamenu_panel
      .filter(function (t) {
        return t !== event.target
      })
      .forEach(collapse)
  }
  var toggler_megamenu_panel = Array.prototype.slice.call(
    document.querySelectorAll('.nav-megamenu__menus [data-a11y-toggle]')
  )
  // console.log(toggler_megamenu_panel);
  toggler_megamenu_panel.forEach(function (toggle) {
    toggle.addEventListener('click', collapseAll_megamenu_panel)
  })


  // 3 > jquery - removing scrolling from Body when Menu is opened
  // Large Desktop
  $('.nav--main > li > a[aria-expanded], .nav--main .navbar__toggler-level2').on('click', function () {

    var dataAriaValue = $(this).attr("aria-expanded");
    // console.log("The aria-expanded of clicked item is: " + dataAriaValue);

    if ( dataAriaValue === "false" ) {
      $('body').addClass('nav-is-opened');
      // console.log('MegaMenu ouvert');
      megaMenuOverlay();

    } else {
      $('body').removeClass('nav-is-opened');
      // console.log('MegaMenu rien d ouvert');
      megaMenuOverlayRemove();
    }

  });


  // > Handling OVERFLOW on BODY
  // Small Desktop or Mobile (burger menu)
  $('#navbarMainNav').on('shown.bs.collapse', function () {
    // do something...
    $('body').addClass('nav-is-opened');
    // We add a class for Mobile version so that Overflow is still active on Body - Overflow removed by a click on a spceific button
    $('body').addClass('nav-mobile-is-opened');
    //console.log('BS4 Burger Menu ouvert');
    // We add an Overlay for Closure Mechanism
    megaMenuOverlay();
  })
  $('#navbarMainNav').on('hidden.bs.collapse', function () {
    // do something...
    $('body').removeClass('nav-is-opened');
    //console.log('BS4 Burger Menu fermé');
    // We remove the Overlay
    megaMenuOverlayRemove();
  })
  // Removing in Mobile Overflow on body (special additional class for overflow)
  $('#js-navbarMainNav__toggler').on('click', function(e) {
    $('body').removeClass('nav-mobile-is-opened');
    // console.log('js-navbarMainNav__toggler has been Clicked => closing mobile Menu!');
  });


  // > Closing all Panels on Resize and removing Class from Body
  var resizeTimer;
  $(window).on('orientationchange', function(e) {

    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function() {
      // Run code here, resizing has "stopped"
      // console.log('Window has been orientationchanged => closing all Menus!');

      collapseAll_navmain (e);
      collapseAll_megamenu_panel (e);

      $('body').removeClass('nav-is-opened');
      $('body').removeClass('nav-mobile-is-opened');
      $('#navbarMainNav').collapse('hide');

      megaMenuOverlayRemove();

    }, 500);

  });


  // > Main MENU Handling Zindex for wayback button in RWD MOBILE
  $('.nav--main > li > [data-a11y-toggle]').on('click', function () {
    // console.log("Niveau 1 cliqué");
    $(this).next('.nav-megamenu__wrapper').css("z-index","1");

  });

  $('.nav-megamenu__menu-l2>.has-menu>[data-a11y-toggle][aria-expanded="false"]').on('click', function () {
    // console.log("Niveau 2 cliqué");
    $(this).parents().find('.nav-megamenu__wrapper').css("z-index","2");
  });

  // > Checking state of ARIA when gets to TRUE on looking onto DOCUMENT
  $(document).on('click', '.nav-megamenu__menu-l2>.has-menu>[data-a11y-toggle][aria-expanded="true"]', function (e) {
    // console.log("Niveau 2 RE-cliqué vers 1");
    $(this).parents().find('.nav-megamenu__wrapper').css("z-index","1");

  });

  // > Overlay and Closure Mechanism
  // > Adding Overlay
  function megaMenuOverlay() {
    //
    $('.menu__overlay').remove();
    $('header').after('<div class="menu__overlay"></div>');
  }
  // > Removing Overlay
  function megaMenuOverlayRemove() {
    //
    $('.menu__overlay').remove();
  }
  // > Watching for a click to launch Closure Mechanism
  $(document).on('click', '.menu__overlay', function (e) {
    // console.log("menu__overlay clicked !");
    megaMenuOverlayRemove();

    collapseAll_navmain (e);
    collapseAll_megamenu_panel (e);

    $('body').removeClass('nav-is-opened');
    $('body').removeClass('nav-mobile-is-opened');
    $('#navbarMainNav').collapse('hide');

  });


};
